import { Search } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const statusLabels: Record<string, string> = {
  new: "Nova",
  processing: "U obradi",
  fulfilled: "Isporučena",
  cancelled: "Otkazana",
};

const ALL_STATUSES = ["all", "new", "processing", "fulfilled", "cancelled"] as const;

interface OrdersFilterBarProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  statusFilter: string;
  onStatusFilterChange: (value: string) => void;
  shippingFilter: string;
  onShippingFilterChange: (value: string) => void;
}

export default function OrdersFilterBar({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  shippingFilter,
  onShippingFilterChange,
}: OrdersFilterBarProps) {
  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
      <div className="relative flex-1 min-w-0">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-muted-foreground pointer-events-none" />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Traži po imenu, broju narudžbe ili ID najave..."
          className="w-full rounded-lg border border-border bg-white pl-9 pr-3 py-2 text-sm h-9 focus:ring-1 focus:ring-foreground focus:border-foreground outline-none"
        />
      </div>
      <div className="flex gap-2 sm:items-center">
        <Select value={statusFilter} onValueChange={onStatusFilterChange}>
          <SelectTrigger className="flex-1 sm:w-auto min-w-[140px] h-9 rounded-lg border-border text-sm shrink-0">
            <SelectValue placeholder="Svi statusi" />
          </SelectTrigger>
          <SelectContent>
            {ALL_STATUSES.map((s) => (
              <SelectItem key={s} value={s}>
                {s === "all" ? "Svi statusi" : statusLabels[s]}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Select value={shippingFilter} onValueChange={onShippingFilterChange}>
          <SelectTrigger className="flex-1 sm:w-auto min-w-[150px] h-9 rounded-lg border-border text-sm shrink-0">
            <SelectValue placeholder="Sve narudžbe" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Sve narudžbe</SelectItem>
            <SelectItem value="pickup">Lično preuzimanje</SelectItem>
            <SelectItem value="delivery">Dostava</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
